import React from 'react';
import { ContentPanel } from '../../../../../../components/ContentPanel';
import { SidebarPanelTitle } from '../../../../../../components/content-side-bar/SidebarPanelTitle';
import { MemberAvatarAndName } from '@components/MemberAvatarAndName';
import { Stack, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IManagersSidebarPanel } from './interfaces';

export const ManagersSidebarPanel: React.FC<IManagersSidebarPanel> = ({
  managers,
}): JSX.Element | null => {
  const { t } = useTranslation();

  if (managers.length === 0) {
    return null;
  }

  return (
    <ContentPanel borderRadius="none">
      <SidebarPanelTitle
        title={t('competitions:portal.details.managersPanel.title')}
        sx={{ mb: '12px' }}
      />
      <Stack spacing={1.25}>
        {managers.map((manager) => (
          <Box
            key={manager.slug}
            sx={{
              '& .MuiTypography-root': {
                fontSize: '.8rem',
              },
            }}
          >
            <MemberAvatarAndName
              slug={manager.slug}
              name={manager.fullName}
              size="28px"
            />
          </Box>
        ))}
      </Stack>
    </ContentPanel>
  );
};
